import { ReactNode } from 'react';
import {
  RoleEnum,
  FormActionsStatus,
  FormActionsRequired,
  TeacherRecommendationStatus,
  FormNames,
  CounselorFormStatus,
} from '@youscience/commonapp-service-common';
import { SortDirection } from '@common-types';
import { OptionalNullableDateString } from '@constants/commonApp/types';

export enum SortByEnum {
  NAME = 'Name',
  DEADLINE = 'Deadline',
}

export interface SortByValues {
  sort: SortByEnum;
  sortDirection: SortDirection;
}

export interface RecommenderInfo {
  fullName: string;
  displayName: string;
  email: string;
  phone: string;
  roles?: RoleEnum[];
}

export interface RecommenderInfoUpdateResponse {
  tenantId: string;
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  roles?: RoleEnum[];
}

export interface ApplicantFormRequests {
  applicantId: number;
  legalName: string;
  deadline: string | null;
  actionsRequired: FormActionsRequired[];
  status: FormActionsStatus;
}

export interface HeadCell {
  id: keyof ApplicantFormRequests | string;
  label: string | ReactNode;
}

export interface Teacher {
  recommenderId: number;
  firstName: string;
  lastName: string;
  subject: string;
  recommendation: {
    status: TeacherRecommendationStatus;
    submittedDate: OptionalNullableDateString | Date;
    downloadedDate: OptionalNullableDateString | Date;
  };
}

export interface Counselor {
  recommenderId: number;
  forms: {
    type: FormNames;
    submittedDate: OptionalNullableDateString | Date;
    downloadedDate: OptionalNullableDateString | Date;
    status: CounselorFormStatus;
    formActionStatus: FormActionsStatus | null;
  }[];
}

export enum TabSections {
  ClassRank = 'classRank',
  GPA = 'gpa',
  Curriculum = 'curriculum',
  Ratings = 'ratings',
  Transcripts = 'transcripts',
  EconomicNeed = 'economicNeed',
  Summary = 'summary',
  OtherUpdates = 'otherUpdates',
  Agreement = 'agreement',
  WrittenEvaluation = 'writtenEvaluation',
}

export enum TeacherTabSections {
  WrittenEvaluation = 'writtenEvaluation',
  Ratings = 'ratings',
  SubjectArea = 'subjectArea',
}
